import { client } from '@/client';
import { OperationLogsResponse } from '@/client/operation-log';
import { useQuery, UseQueryResult } from 'react-query';

export const OPERATION_LOGS_QUERY_KEY = 'operationLogs';

export const useOperationLogs = (
  accountId: string | undefined,
  enabled = true,
): UseQueryResult<OperationLogsResponse> & {
  operationLogs: OperationLogsResponse | undefined;
} => {
  const { data, ...rest } = useQuery(
    [OPERATION_LOGS_QUERY_KEY, accountId],
    () => client.operationLogs.getOperationLogs(accountId as string),
    {
      enabled: enabled && !!accountId,
      staleTime: 30000,
    },
  );

  return {
    operationLogs: data,
    ...(rest as UseQueryResult<OperationLogsResponse>),
  };
};
